import React from 'react';
const logo = '/logo.png';

export default function Footer() {
  return (
    <footer style={{
      background: '#080810',
      borderTop: '1px solid rgba(124,58,237,0.1)',
      padding: '3rem 2rem',
    }}>
      <div style={{
        maxWidth: 1100, margin: '0 auto',
        display: 'flex', justifyContent: 'space-between',
        alignItems: 'center', flexWrap: 'wrap', gap: '1.5rem',
      }}>
        {/* Logo */}
        <div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 6 }}>
            <img src={logo} alt="SoftyPusher" style={{ height: 32, width: 32, borderRadius: 8 }} />
            <span style={{ fontFamily: 'Plus Jakarta Sans, sans-serif', fontWeight: 700, fontSize: 17, color: '#fff' }}>
              Softy<span style={{ color: '#A78BFA' }}>Pusher</span>
            </span>
          </div>
          <p style={{ color: '#4a4a5a', fontSize: 13, fontStyle: 'italic' }}>"We push, you grow."</p>
        </div>

        {/* Links */}
        <div style={{ display: 'flex', gap: '2rem' }}>
          {['#hero', '#pricing', '#contact'].map((href, i) => (
            <a key={href} href={href} style={{
              color: '#8b8b9a', textDecoration: 'none', fontSize: 14,
              transition: 'color 0.2s',
            }}
              onMouseEnter={e => e.target.style.color = '#fff'}
              onMouseLeave={e => e.target.style.color = '#8b8b9a'}
            >{['Accueil', 'Tarifs', 'Contact'][i]}</a>
          ))}
        </div>

        {/* Right */}
        <div style={{ textAlign: 'right' }}>
          <p style={{ color: '#4a4a5a', fontSize: 13 }}>
            A <span style={{ color: '#7C3AED' }}>SoftyGroup</span> project
          </p>
          <p style={{ color: '#4a4a5a', fontSize: 12 }}>© 2026 SoftyPusher. Tous droits réservés.</p>
        </div>
      </div>

      {/* Pipeline badge */}
      <div style={{ textAlign: 'center', marginTop: '2rem' }}>
        <span style={{
          display: 'inline-flex', alignItems: 'center', gap: 6,
          background: 'rgba(124,58,237,0.1)',
          border: '1px solid rgba(124,58,237,0.2)',
          borderRadius: 20, padding: '4px 14px',
          fontSize: 11, color: '#7C3AED', fontWeight: 600,
          letterSpacing: '0.08em',
        }}>
          <span style={{
            width: 5, height: 5, borderRadius: '50%',
            background: 'rgb(0, 255, 0)', display: 'inline-block',
            animation: 'pulse-dot 2s infinite',
          }} />
          PIPELINE IA ACTIF
        </span>
      </div>

      <style>{`
        @media (max-width: 600px) {
          footer > div > div { text-align: center !important; }
          footer > div { justify-content: center !important; }
        }
      `}</style>
    </footer>
  );
}
